import React from "react";
import { FormattedMessage } from "react-intl";
import Container from "react-bootstrap/Container";

export default function AboutUs() {
  return (
    <div className="content-wrapper">
      <Container>
        <div className="real-content py-12" itemProp="text">
          <h1 className="text-2xl font-bold mb-6">
            <FormattedMessage id="about-us.title" />
          </h1>
          <p className="text-base leading-relaxed">
            <FormattedMessage id="about-us.content" />
          </p>
        </div>
      </Container>
    </div>
  );
}
